import { delay } from '@/utils/constants';
import { chunk } from 'lodash';

const DEAL_POLICY_CHUNKS = 20;

export const retrieveDealPolicyChunks = async ({
	dealIds,
	includeTransactions,
	showLatest,
	dispatch,
	onChunkSuccess,
	onChunkError,
	dealsApi,
}) => {
	const dealIdChunks = chunk(dealIds, DEAL_POLICY_CHUNKS);

	for (let index = 0; index < dealIdChunks.length; index++) {
		const dealIdChunk = dealIdChunks[index];
		try {
			const resultByDealId =
				(await dispatch(
					dealsApi.endpoints.getDealPoliciesChunk.initiate(
						{
							dealIds: dealIdChunk,
							includeTransactions,
							showLatest,
						},
						{
							subscribe: false,
						},
					),
				).unwrap()) ?? {};

			const successfulDealIds = dealIdChunk.filter((dealId) =>
				Object.prototype.hasOwnProperty.call(resultByDealId, dealId),
			);

			if (successfulDealIds.length > 0) {
				dispatch(
					dealsApi.util.upsertQueryEntries(
						successfulDealIds.map((dealId) => ({
							endpointName: 'getDealListPoliciesByDealId',
							arg: {
								dealId,
								includeTransactions,
								showLatest,
							},
							value: resultByDealId[dealId],
						})),
					),
				);
			}

			await onChunkSuccess?.({
				dealIdChunk,
				resultByDealId,
			});
		} catch (error) {
			await onChunkError?.({
				dealIdChunk,
				error,
			});
		}
		if (index > 0 && index < dealIdChunks.length - 1) await delay();
	}
};
